var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState, useCallback, useEffect, } from "react";
import moment from "moment";
import { ErrorDb } from "../utils/indexedDB/db";
var Context = createContext(null);
var Provider = function (props) {
    var _a = useState({
        isTransitioning: false,
        errors: [],
    }), state = _a[0], setState = _a[1];
    useEffect(function () {
        if (props.isDrawerOpen) {
            setState(function (prev) { return (__assign(__assign({}, prev), { isTransitioning: true })); });
            setTimeout(function () {
                setState(function (prev) { return (__assign(__assign({}, prev), { isTransitioning: false })); });
            }, 300);
        }
    }, [props.isDrawerOpen]);
    var fetchErrors = useCallback(function () {
        if (props.errorExpiryHour) {
            ErrorDb.deleteObjectsByRange("dateIndex", 0, moment().subtract(props.errorExpiryHour, "hour").valueOf()).then(function () {
                ErrorDb.getAllObjects().then(function (values) {
                    setState(function (prev) { return (__assign(__assign({}, prev), { errors: values })); });
                });
            });
        }
        else {
            ErrorDb.getAllObjects().then(function (values) {
                setState(function (prev) { return (__assign(__assign({}, prev), { errors: values })); });
            });
        }
    }, [props.errorExpiryHour]);
    var deleteAllErrors = useCallback(function () {
        ErrorDb.deleteAllObjects().then(function () {
            fetchErrors();
        });
    }, [fetchErrors]);
    var deleteErrorById = useCallback(function (id) {
        ErrorDb.deleteObjectById(id).then(function () {
            fetchErrors();
        });
    }, [fetchErrors]);
    var values = useMemo(function () { return (__assign(__assign({}, state), { fetchErrors: fetchErrors, deleteAllErrors: deleteAllErrors, deleteErrorById: deleteErrorById })); }, [state, fetchErrors, deleteAllErrors, deleteErrorById]);
    return (_jsx(Context.Provider, __assign({ value: values }, { children: props.children(values) })));
};
export var useConsumers = function () { return useContext(Context); };
export { Provider };
